// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2kuVF","productName":"Table_productName__1jniw"};